// IE 10/11 Media Query hack
export const mediaIE11Hack =
  'screen and (-ms-high-contrast: active), (-ms-high-contrast: none)'
